// src/ui/controls/slider.ts

export interface SliderOpts {
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (v: number) => void;
}

export function createSlider(o: SliderOpts): HTMLDivElement {
  const wrap = document.createElement('div');
  wrap.className = 'slider-row';
  wrap.style.display = 'block';

  const lab = document.createElement('label');
  lab.textContent = o.label;

  const grid = document.createElement('div');
  grid.style.display = 'grid';
  grid.style.gridTemplateColumns = '1fr 60px';
  grid.style.gap = '8px';
  grid.style.alignItems = 'center';

  const range = document.createElement('input');
  range.type = 'range';
  range.min = String(o.min); range.max = String(o.max);
  range.step = String(o.step); range.value = String(o.value);

  const num = document.createElement('input');
  num.type = 'number';
  num.min = String(o.min); num.max = String(o.max);
  num.step = String(o.step); num.value = String(o.value);

  const emit = (v: number) => { o.onChange(v); };

  range.addEventListener('input', () => {
    const v = Number(range.value);
    num.value = String(v);
    emit(v);
  });
  num.addEventListener('change', () => {
    let v = Number(num.value);
    if (Number.isNaN(v)) v = o.value;
    v = Math.max(o.min, Math.min(o.max, v));
    range.value = String(v); num.value = String(v);
    emit(v);
  });

  grid.append(range, num);
  wrap.append(lab, grid);
  return wrap;
}
